module.exports = __webpack_public_path__ + "static/img/23.ca6314b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/23.jpg
// module id = s6tV
// module chunks = 0